<template>
  <validation-provider rules="required|min:1"
                       v-slot="{ errors }"
                       :name="validationProviderName">
    <LabelPrimary>
      {{ label }}
    </LabelPrimary>
    <InputTextPrimary v-model="name"
                      v-bind="$attrs"
                      v-on="$listeners"
                      :placeholder="placeholder" />
    <FormErrorPrimary>
      {{ errors[0] }}
    </FormErrorPrimary>
  </validation-provider>
</template>

<script>
  import FormErrorPrimary from '@modules/input/form-error-primary'
  import InputTextPrimary from '@modules/input/input-text-primary'
  import LabelPrimary from '@modules/input/label-primary'
  import { ValidationProvider } from 'vee-validate'
  import { min, required } from '@js/validators/rules'

  export default {
    name: 'FormNamePrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'input',
    },
    components: {
      FormErrorPrimary,
      InputTextPrimary,
      LabelPrimary,
      ValidationProvider,
    },
    props: {
      vmodelValue: { type: String },
      label: { type: String, required: false, default: 'First name' },
      placeholder: { type: String, required: false, default: 'Your first name'},
      validationProviderName: { type: String, required: false, default: 'first name' },
    },
    data: function () {
      return {
        name: this.vmodelValue,
      };
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.name = newVal;
      },
    },
  };
</script>
